const rules = {
  participant: {
    static: [],
    dynamic: {
      'edit profile': ({ userProfileId, profileId }) => {
        if (!userProfileId || !profileId) return false;
        return userProfileId === profileId;
      }
    }
  },
  resource_person: {
    static: [],
    dynamic: {
      'edit profile': ({ userProfileId, profileId }) => {
        if (!userProfileId || !profileId) return false;
        return userProfileId === profileId;
      }
    }
  },
  executive: {
    static: [
      'view suspended events',
      'remove event resource person',
      'edit session complete',
      'create session',
      'update attendance',
      'export files',
      'edit event'
    ],
    dynamic: {
      'edit profile': ({ userProfileId, profileId }) => {
        if (!userProfileId || !profileId) return false;
        return userProfileId === profileId;
      }
    }
  },
  cd_admin: {
    static: [
      'view suspended events',
      'remove event resource person',
      'edit session complete',
      'create session',
      'export files',
      'edit event',
      'update attendance',
      'suspend event',
      'Can add resource person',
      'Can promote'
      // 'Can add executive'
    ],
    dynamic: {
      'unsuspend event': ({ cdAdminId, eventCreatedById }) => {
        if (!cdAdminId || !eventCreatedById) return false;
        return cdAdminId === eventCreatedById;
      },
      'update post event activity': ({ cdAdminId, eventCreatedById }) => {
        if (!cdAdminId || !eventCreatedById) return false;
        return cdAdminId === eventCreatedById;
      },
      'edit profile': ({ userProfileId, profileId }) => {
        if (!userProfileId || !profileId) return false;
        return userProfileId === profileId;
      }
    }
  }
};

export default rules;
